const INSTANT_REPORT_STATUS = {
  GENERATING: 'Generating',
  GENERATED: 'Generated',
};

export { INSTANT_REPORT_STATUS };
